module.exports = __webpack_public_path__ + "static/img/968f7e3e-2026-426d-a4b5-f305e47b89dd.e48ad235.png";